import styled from "styled-components";

export const UsagesContainer = styled.section`
  /* width: 100%; */
  margin-bottom: 12rem;
  margin-top: 34rem;
  & > div {
    margin: 0 auto;
    margin-bottom: 9rem;
    text-align: center;
    p {
      width: 960px;
      margin: auto;
    }
  }
  h2 {
    font-size: 4.8rem;
    font-weight: 80rem;
    text-align: center;
    color: var(--primary-color);
    margin-bottom: 8.6rem;
    @media (max-width: 560px) {
      font-size: 3.4rem;
    }
  }
  @media (max-width: 1430px) {
    padding: 0 18rem;
    & > div {
      p {
        width: 800px;
      }
    }
  }
  @media (max-width: 1115px) {
    padding: 0 7rem;
    & > div {
      p {
        width: unset;
      }
    }
  }

  @media (max-width: 1024px) {
    padding: 6rem !important;
    margin-top: 2rem;
  }

  @media (max-width: 1024px) {
    padding-top: 0rem !important;
    margin-top: 0rem;
    margin-bottom: 0%;
  }

  @media (max-width: 560px) {
    margin-top: 7rem;
  }
  @media (max-width: 480px) {
    margin-top: 0rem;
  }
`;
